import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Draggable from 'react-draggable';
import cn from 'classnames';
import moment from 'moment';
import throttle from 'lodash/throttle';
import DirectionHorizontalArrow from 'svg/directionHorizontalArrow.svg';
import App from 'modules/App';
import { useCustomRanges } from 'modules/PatientResults/hooks';
import { TREND_CHART_MIN_RANGE } from '../../constants';
import { getTimestampFromX } from './helpers';
import styles from './GlucoseConcentrationTrend.pcss';
const CustomRangeDragButton = ({ innerHeight, margin, xScale, idx, tickValues, isReadOnly, updatePhiSet })=>{
    const direction = useSelector(App.selectors.direction);
    const customRanges = useCustomRanges();
    const timestamp = tickValues[idx];
    const prevTimestamp = tickValues[idx - 1];
    const nextTimestamp = tickValues[idx + 1];
    const leftTimestamp = direction === 'ltr' ? prevTimestamp : nextTimestamp;
    const rightTimestamp = direction === 'ltr' ? nextTimestamp : prevTimestamp;
    const [labelMoment, setLabelMoment] = useState(moment.unix(timestamp).utc());
    const rawX = xScale(timestamp);
    const x = rawX - 15;
    const minRange = direction === 'ltr' ? TREND_CHART_MIN_RANGE : -TREND_CHART_MIN_RANGE;
    const leftConstraint = xScale(leftTimestamp + minRange) - 15;
    const rightConstraint = xScale(rightTimestamp - minRange) - 15;
    const stopDragCustomRange = (_, data)=>{
        if (!customRanges[idx]) return;
        const newTimestamp = getTimestampFromX(data.x, xScale);
        const newMomentDate = moment.unix(newTimestamp).utc().locale('en');
        const updatedCustomRanges = [
            ...customRanges
        ];
        updatedCustomRanges[idx] = [
            newMomentDate.hour(),
            newMomentDate.minutes(),
            customRanges[idx][2]
        ];
        updatePhiSet({
            customRanges: updatedCustomRanges
        });
    };
    const onDrag = (_, data)=>{
        if (!customRanges[idx]) return;
        const newTimestamp = getTimestampFromX(data.x, xScale);
        const newMomentDate = moment.unix(newTimestamp).utc();
        setLabelMoment(newMomentDate);
    };
    const onDragStop = throttle(stopDragCustomRange, 200);
    return /*#__PURE__*/ _jsx(Draggable, {
        axis: "x",
        bounds: {
            left: leftConstraint,
            right: rightConstraint
        },
        defaultPosition: {
            x,
            y: -20
        },
        disabled: isReadOnly,
        onDrag: onDrag,
        onStop: onDragStop,
        children: /*#__PURE__*/ _jsxs("g", {
            className: styles.customRange__change,
            children: [
                !isReadOnly && /*#__PURE__*/ _jsx("foreignObject", {
                    className: styles.customRange__drag__btnFObj,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.customRange__drag__btn,
                        children: /*#__PURE__*/ _jsx(DirectionHorizontalArrow, {
                            className: styles.customRange__label__icon
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("foreignObject", {
                    style: {
                        width: '9px',
                        height: innerHeight + margin.bottom - (isReadOnly ? 40 : 0),
                        transform: `translate(11px, ${isReadOnly ? 2 : 3}rem)`
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.customRange__drag__line, {
                            [styles['customRange__drag__line--readOnly']]: isReadOnly
                        }),
                        children: /*#__PURE__*/ _jsx("div", {})
                    })
                }),
                !isReadOnly && /*#__PURE__*/ _jsx("text", {
                    className: styles.customRange__drag__valueInfo,
                    children: labelMoment.format('LT')
                })
            ]
        })
    });
};
export default CustomRangeDragButton;
